import { render, staticRenderFns } from "./BaseNested.vue?vue&type=template&id=53a48480&lang=pug&"
import script from "./BaseNested.vue?vue&type=script&lang=js&"
export * from "./BaseNested.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports